<template>
  <transition
   name="pa-simple-fade"
   @enter="handleEnter"
  >
    <div v-if="isOpen" class="pa-ink-counter-modal" :x-placement="placement">
      <div class="content-wrapper" ref="contentWrapper">
        <div class="content">
          <p class="pa-title">インクの貯蔵量</p>
          <div class="total-view">
            <p class="pa-caption">インクの総量</p>
            <p class="pa-value">{{characterInkStore.total_ink_count | mutateFullWidth}}</p>
          </div>
          
          <p class="pa-mini">最短のインク有効期限:{{characterInkStore.latest_expire_date | mutateJPFullWidthOnlyDate}}</p>
          <p class="pa-mini">最短の有効期限のインク量:{{characterInkStore.latest_expire_ink_count | mutateFullWidth}}染</p>
        </div>
      </div>

      <div class="arrow-wrapper" ref="arrowWrapper">
        <div class="arrow-field"></div>
      </div>
    </div>
  </transition>
</template>

<script>
import {GetCharacterInkStore} from '@/graphql/queries/Character.graphql'

export default {
  props : {
    isOpen : {
      default: false
    },

    placement : {
      default: 'top'
    }
  },

  apollo : {
    characterInkStore : {
      query : GetCharacterInkStore
    }
  },

  methods : {
    handleEnter(){
      switch(this.placement){
        case 'bottom':
          this.setArrowPositionBottom();
          this.setContentPositionBottom();
        break;
        
        case 'top':
          this.setArrowPositionTop();
          this.setContentPositionTop();
        break;
      }
    },

    setArrowPositionBottom(){
      const BannerRect = this.$parent.$refs.counterBanner.getBoundingClientRect();
      
      this.$refs.arrowWrapper.style.width = window.innerWidth+'px';

      this.$refs.arrowWrapper.style.width = BannerRect.width + 'px';
    },

    setContentPositionBottom(){
      const contentRect = this.$refs.contentWrapper.getBoundingClientRect();

      // モバイルの場合、leftとwidthを併せると画面サイズを超える場合があり、その場合は中央に配置
      if( (contentRect.x + this.$refs.contentWrapper.offsetWidth) > window.innerWidth ){
        this.$refs.contentWrapper.style.width = window.innerWidth+'px';
        this.$refs.contentWrapper.style.left = '-' + parseInt(contentRect.x) + 'px';
      }
    },

    setArrowPositionTop(){
      const BannerRect = this.$parent.$refs.counterBanner.getBoundingClientRect();

      this.$refs.arrowWrapper.style.bottom = BannerRect.height + 10 + 'px';
      this.$refs.arrowWrapper.style.width = BannerRect.width + 'px';
    },

    setContentPositionTop(){
      const contentRect = this.$refs.contentWrapper.getBoundingClientRect();
      const BannerRect = this.$parent.$refs.counterBanner.getBoundingClientRect();

      // 上に表示する場合はbottomをつけます。
      this.$refs.contentWrapper.style.bottom = BannerRect.height + 10 + 'px';

      // モバイルの場合、leftとwidthを併せると画面サイズを超える場合があり、その場合は中央に配置
      if( (contentRect.x + this.$refs.contentWrapper.offsetWidth) > window.innerWidth ){
        this.$refs.contentWrapper.style.width = window.innerWidth+'px';
        this.$refs.contentWrapper.style.left = '-' + parseInt(contentRect.x) + 'px';
      }
    }
  }
}
</script>

<style lang="scss">
.pa-ink-counter-modal{
  position: absolute;
  z-index: 10;

  .content-wrapper{
    position: absolute;
    top:0;
    left:0;
    z-index:10;

    .content{
      min-width:320px;
      max-width:320px;
      margin:0 auto;
      background:gray;
      background-color: rgba(189, 181, 181, 1);
      border-radius:4px;
      color:#7E7972;

      p.pa-title{
        text-align: center;
        font-size:1.4rem;
        border-bottom:1px solid #C4BAB1;
        width:90%;
        margin:0 auto;
        padding:.2rem 0;
        color:#7E7972;
      }

      div.total-view{
        width:90%;
        margin:0 auto;
        border-bottom:1px solid #B5AAA1;

        p.pa-caption{
          text-align: center;
          font-size:.7rem;
          padding:.4rem 0 0;
          margin-bottom:0;
        }

        p.pa-value{
          font-size:2.5rem;
          line-height: 1;
          font-weight: bold;
          text-align: center;
          letter-spacing: 1px;
          padding:.1rem 0 .4rem;
        }
      }

      p.pa-mini{
        margin:.4rem 0 0;
        font-size:.67rem;
        text-align: center;

        &:last-child{
          margin-top:0;
          padding-bottom:.4rem;
        }
      }
    }
  }

  .arrow-wrapper{
    position: absolute;
    top:0;
    left:0;
    background-color: red;
    
    .arrow-field{
      position: absolute;
      margin:0 auto;
      border-style: solid;
      border-color: #ffffff; /* #ffc107, #35495e */
      border-color: rgba(189, 181, 181, 1);
      &--dark {
        border-color: #ffffff;
        border-color: rgba(189, 181, 181, 1);
      }
    }
  }
  
  &[x-placement^="bottom"] {
    margin-top: 0.5rem;

    .arrow-wrapper {
      .arrow-field{
        // position: absolute;
        border-width: 0 0.5rem 0.5rem 0.5rem;
        border-left-color: transparent;
        border-right-color: transparent;
        border-top-color: transparent;
        top: -0.5rem;
        // left: calc(50% - 1rem);
        left:45%;
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }

  &[x-placement^="top"] {
    margin-bottom: 0.5rem;

    .content-wrapper{
      top:initial;
      left:0;
    }

    .arrow-wrapper {
      top:initial;

      .arrow-field {
        position: absolute;
        border-width: 0.5rem 0.5rem 0 0.5rem;
        border-left-color: transparent;
        border-right-color: transparent;
        border-bottom-color: transparent;
        bottom: -0.5rem;
        // left: calc(50% - 1rem);
        left:45%;
        margin-top: 0;
        margin-bottom: 0;
      }
    }
  }
}
</style>